import React, { useState, useEffect } from "react";
import { Container, Typography } from "@mui/material";
import CustomAppBar from "../../components/AppBar";
import CustomButton from "../../components/Custom/CustomButton";
import SingleCustomCard from "../../components/Custom/SingleCustomCard";
import DocumentIcon from "../../assets/Icon/DocumentFpoIcon.png";
import LoaderContainer from "../../components/LoaderContainer";
import api from "../../globals/axios";
import { useNavigate } from "react-router-dom";
import { SERVER_BASE_ADDRESS } from "../../globals/const";
import { useTranslation } from "react-i18next";
import { CustomTitle } from "../../components/Custom/CustomTypography";

export default function DocumentList() {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(true);
  const [documents, setDocuments] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    api
      .get("/fpo/documents/")
      .then((response) => {
        if (response && response.data) {
          setDocuments(response.data);
          setLoading(false);
        }
      })
      .catch((error) => {
        console.error("Error fetching documents:", error);
        setLoading(false);
      });
  }, []);

  const handleView = (documentUrl) => {
    window.open(documentUrl, "_blank"); // Open document in a new tab
  };

  const downloadDocument = (documentId) => {
    window.open(
      `${SERVER_BASE_ADDRESS}/fpo/download_file/?identifier=${documentId}&file_type=document`
    );
  };

  const handleDelete = (documentId) => {
    api.delete(`/fpo/document/${documentId}/`).then((response) => {
      console.log("Document deleted successfully", response);
      setDocuments(documents.filter((doc) => doc.id !== documentId));
      alert("Document deleted successfully");
    });
  };

  const handleAddDocuments = () => {
    navigate("/fpo/documents");
  };

  return (
    <>
      <CustomAppBar />
      <LoaderContainer loading={loading}>
        <Container maxWidth="xs">
          {documents.length !== 0 && (
            <>
              <CustomTitle> {t("Documents")}</CustomTitle>
              <div
                style={{
                  overflowY: "auto",
                  maxHeight: "calc(115vh - 200px)",
                  textAlign: "center",
                  height: "70vh",
                  margin: "auto",
                }}
              >
                {documents.map((data) => (
                  <SingleCustomCard
                    key={data.id}
                    data={[{ value: data.name }]}
                    onView={() => handleView(data.document)}
                    onUpload={() => downloadDocument(data.id)}
                    onDelete={() => handleDelete(data.id)}
                    showIcons={true}
                  />
                ))}
              </div>
            </>
          )}
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexDirection: "column",
              height: documents.length !== 0 ? "20vh" : "90vh",
            }}
          >
            {documents.length === 0 && (
              <img
                src={DocumentIcon}
                alt="financial"
                style={{
                  width: "127px",
                  height: "127px",
                }}
              />
            )}
            <CustomButton onClick={handleAddDocuments}>
              {t("Add Documents")}
            </CustomButton>
            {documents.length === 0 && (
              <Typography variant="subtitle1">
                {t("Your Documents will be shown here once you add them.")}
              </Typography>
            )}
          </div>
        </Container>
      </LoaderContainer>
    </>
  );
}
